module.exports = __webpack_public_path__ + "static/abr-logo-37ac44d3ad562ae317cf9ec0ee8ddec6.jpeg";